import { IFinancialStatements } from '@Domains/FinancialStatements';
import { Role } from 'src/Enum/Report';
import { IFinancialStatementsFormValues } from '../FinancialStatementsProvider/types';

export const mappingFinancialStatementsToFormValues = (
  response: IFinancialStatements
): IFinancialStatementsFormValues => {
  return {
    id: response.id,
    completedSection: {
      id: response.completedSection?.id ?? 0,
      isCompletedTh: response.completedSection?.isCompletedTh ?? false,
      isCompletedEn: response.completedSection?.isCompletedEn ?? false,
      roleStampTh: response.completedSection?.roleStampTh ?? Role.NONE,
      roleStampEn: response.completedSection?.roleStampEn ?? Role.NONE,
      dateTh: response.completedSection?.dateTh ?? undefined,
      dateEn: response.completedSection?.dateEn ?? undefined,
    },
    otherDescriptions: (response.otherDescriptions ?? []).map((desc) => ({
      titleTh: desc.titleTh ?? '',
      titleEn: desc.titleEn ?? '',
      descriptionTh: desc.descriptionTh ?? '',
      descriptionEn: desc.descriptionEn ?? '',
    })),
  };
};
